import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import { toast } from 'react-toastify';
import actionTypes from '../actionTypes';

export function* updateRefCode({ payload }) {
  try {
    const res = yield call(api, {
      method: 'put',
      url: URL.REF_SETTINGS,
      data: { referral_code: payload.referralCode },
    });
    const { data } = res;
    yield put({ type: 'UPDATE_REF_CODE_SUCCESS', data });
    yield call(toast.success, 'Referral Code was updated');
  } catch (e) {
    yield put({ type: 'UPDATE_REF_CODE_ERROR' });
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.UPDATE_REF_CODE, updateRefCode);
}
